import Avatar from 'components/base/Avatar';
import { useState } from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import { useAppContext } from 'providers/AppProvider';
import ThemeToggler from 'components/common/ThemeToggler';
import { RootState } from 'redux/rootReducer';
import { useSelector } from 'react-redux';

const NavItems = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();
  const userProfile = useSelector(
    (state: RootState) => state.userProfile.userProfile
  );
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  return (
    <div className="navbar-nav navbar-nav-icons flex-row ">
      <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item>
      {/* <Nav.Item
        className={classNames({
          'd-lg-none':
            navbarPosition === 'vertical' || navbarPosition === 'dual'
        })}
      >
        <Nav.Link onClick={() => setOpenSearchModal(!openSearchModal)}>
          <FeatherIcon icon="search" size={19} style={{ marginBottom: 2 }} />
        </Nav.Link>
      </Nav.Item> */}
      {/* <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <FeatherIcon icon="bell" size={20} />
          </Dropdown.Toggle>
          <NotificationDropdownMenu />
        </Dropdown>
      </Nav.Item> */}
      {/* <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
            </svg>
          </Dropdown.Toggle>
          <NineDotMenu />
        </Dropdown>
      </Nav.Item> */}
      <Nav.Item>
        <Dropdown
          show={showProfileMenu}
          onToggle={setShowProfileMenu}
          autoClose="outside"
          className="h-100"
        >
          <Dropdown.Toggle
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            <Avatar variant="name" size="xl">
              <span className="p-2">
                {userProfile.first_name.charAt(0) +
                  userProfile.last_name.charAt(0)}
              </span>
            </Avatar>
          </Dropdown.Toggle>
          <ProfileDropdownMenu onClose={() => setShowProfileMenu(false)} />
        </Dropdown>
      </Nav.Item>

      {/* <Modal
        show={openSearchModal}
        onHide={() => setOpenSearchModal(false)}
        className="search-box-modal mt-15"
      >
        <Modal.Body className="p-0 bg-transparent">
          <DropdownSearchBox
            className="navbar-top-search-box"
            inputClassName="rounded-pill"
            size="lg"
            style={{ width: 'auto' }}
          >
            <SearchResult />
          </DropdownSearchBox>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default NavItems;
